import {useStore} from "react-redux";
import {useEffect} from "react";

export const UseReduxActionReducer = (state, action) => {
  return {
    ...state,
    useReduxActionLastAction: action,
  }
}

export const useReduxAction = (onAction, deps) => {
  const store = useStore();

  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      const state = store.getState();
      if (state.useReduxActionLastAction) {
        onAction(state.useReduxActionLastAction)
      }
    });

    return () => {
      unsubscribe();
    };
  }, [store, ...deps]);
}